import { OVERALL_DEPARTMENT_ID } from 'shared/constants/department';
import { v5 } from 'uuid';

export const generateAvatarId = ({
  pulseTemplateId,
  pulseId,
  departmentId = OVERALL_DEPARTMENT_ID,
  avatarNamespace,
}: {
  pulseTemplateId: number;
  pulseId: number;
  departmentId?: number;
  avatarNamespace: string;
}) => {
  const key = `${pulseTemplateId}_${pulseId}_${departmentId}`;

  return v5(key, avatarNamespace);
};
